import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_SERVICE_PAYMENTS].GET_REPORTS_SERVICE_PAYMENTS]: {
		url: '/company/:companyId/reports/service_payments/',
	},
	[ModulesConfigMap[ModulesMap.REPORTS_SERVICE_PAYMENTS].GET_REPORTS_SERVICE_PAYMENT]: {
		url: '/company/:companyId/reports/service_payments/:servicePaymentId/',
	},
	[ModulesConfigMap[ModulesMap.REPORTS_SERVICE_PAYMENTS].GET_REPORTS_SERVICE_PAYMENT_PREVIEW]: {
		url: '/company/:companyId/reports/service_payments/:servicePaymentId/preview/',
	},
}
